import {PolyEngine} from '../../../Poly';
export class AllCamerasRegister {
	static run(poly: PolyEngine) {}
}
